import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { savePaymentMethod } from "../redux/Actions/CartActions";
import Header from "./../components/Header";

const PaymentScreen = ({ history }) => {
  // const [selectPay, setSelectPay] = useState('now');
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  window.scrollTo(0, 0);

  const cart = useSelector((state) => state.cart);
  const { shippingAddress } = cart;

  if (!shippingAddress) {
    history.push("/shipping");
  }

  const [paymentMethod, setPaymentMethod] = useState("now");

  const dispatch = useDispatch();

  const submitHandler = (e) => {
    e.preventDefault();
    // dispatch(savePaymentMethod(paymentMethod));
    window.localStorage.setItem('paymentMethod', paymentMethod)
    if (window.localStorage.getItem('paymentMethod')) {
      history.push("/placeorder");
    }
  };

  console.log(userInfo);

  return (
    <>
      <Header />
      <div className="container d-flex justify-content-center align-items-center login-center">
        <form
          className="Login2 col-md-8 col-lg-4 col-11"
          onSubmit={submitHandler}
        >
          <h6>CHỌN PHƯƠNG THỨC THANH TOÁN</h6>

          <div className="payment-container">
            {
              userInfo ?
                <div className="radio-container">
                  <input
                    checked={paymentMethod == 'point'}
                    className="form-check-input"
                    type="radio"
                    value={paymentMethod}
                    onChange={(e) => setPaymentMethod('point')}
                  />
                  <label className="form-check-label">Thanh toán bằng <img src="/images/logoToken.png" style={{ width: 20 }} /></label>
                </div>
                :
                null
            }
            <div className="radio-container">
              <input
                checked={paymentMethod == 'vnd'}
                className="form-check-input"
                type="radio"
                value={paymentMethod}
                onChange={(e) => setPaymentMethod('vnd')}
              />
              <label className="form-check-label">Thanh toán khi nhận hàng</label>
            </div>

            <div className="radio-container">
              <input
                checked={paymentMethod == 'now'}
                className="form-check-input"
                type="radio"
                value={paymentMethod}
                onChange={(e) => setPaymentMethod('now')}
              />
              <label className="form-check-label">Thanh toán ngay (giảm 50% phí ship)</label>
            </div>




            <div className="radio-container">
              <input
                checked={false}
                className="form-check-input"
                type="radio"
              // value={paymentMethod}
              // onChange={(e) => setPaymentMethod(e.target.value)}
              />
              <label className="form-check-label" style={{ color: "#b5b5b5" }}>Thẻ Visa/Master</label>
            </div>

            <div className="radio-container">
              <input
                checked={false}
                className="form-check-input"
                type="radio"
              // value={paymentMethod}
              // onChange={(e) => setPaymentMethod(e.target.value)}
              />
              <label className="form-check-label" style={{ color: "#b5b5b5" }}>Paypal</label>
            </div>

            <div className="radio-container">
              <input
                checked={false}
                className="form-check-input"
                type="radio"
              // value={paymentMethod}
              // onChange={(e) => setPaymentMethod(e.target.value)}
              />
              <label className="form-check-label" style={{ color: "#b5b5b5" }}>Chuyển khoản IB</label>
            </div>
          </div>

          <button type="submit">
            <Link to="/placeorder" className="text-white">
              Tiếp tục
            </Link>
          </button>
        </form>
      </div>
    </>
  );
};

export default PaymentScreen;